import {
    NavigationBar,
    IconChevronLeftRegular,
    Text2,
    ThemeVariant,
    Spinner,
    Box,
    Text1,
    useElementDimensions,
    skinVars,
} from '@telefonica/mistica';
import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ChatIncidenteContactNumber from '../../../components/ChatIncidentContactNumber';
import ChatMotivesProblem from '../../../components/ChatMotivesProblem';
import ChatNumberProduct from '../../../components/ChatNumberProduct';
import ChatSupportChecks from '../../../components/ChatSupportChecks';
import ChatTabsProducts from '../../../components/ChatTabsProducts';
import './index.scss';
import { getFormatDate } from '../../../utils/dataTransformation/dateConversions';
import ChatDiagnosisDynamic from '../../../components/ChatDiagnosisDynamic';
import {
    IProblemDiagnosis,
    EProblemFeedback,
    EProblemFeedbackType,
    EProblemTypeEvent,
    IProblemEvent,
    IProblemQuestion,
    IProblemResponse,
    IProblemHistoricMessage,
    IProblemInteractionRole,
    IProblemContact,
} from '../../../models/Problems.interfaces';
import {
    getEventsProblemById,
    getListContactsProblems,
    getListMotivesById,
    getProblemById,
    getProblemDialogById,
} from '../../../services/ProblemService';
import { AxiosError, AxiosResponse } from 'axios';
import navigateParams from '../../../utils/navigation/navigateParams';
import { literalsFeedback, LoaderMessage, orderArrayDates } from '../utils.chat';
import ChatSupport from '../../../components/ChatSupport';
import ChatText from '../../../components/ChatText';
import useGlobalRequest, { EGlobalRequest } from '../../../utils/hooks/useGlobalRequest';
import { TrackingEvents } from '../../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../../utils/navigation/controlDevices';
import Stopper from '../../../components/Stopper';
import { managementEnvironment } from '../../../utils/dataTransformation/environments';
import BreadCrumbsWrapper from '../../../components/BreadcrumbsWrapper';
export interface IChatComponent {
    step: number;
    product: IProblemDiagnosis;
}
interface IChatItemComponent {
    component: JSX.Element;
}

export const SolveIncident: React.FC = () => {
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const currentDate = new Date();
    const [products] = useGlobalRequest(EGlobalRequest.PRODUCTS) as any;
    const { height, ref } = useElementDimensions();
    const { trackingScreenView } = new TrackingEvents();
    const supportDisabled = managementEnvironment().REACT_APP_STOPPER_PROBLEMS_DISABLED;
    const [messages, setMessages] = useState<IProblemHistoricMessage[] | null>(null);
    const [dateIssue, setDateIssue] = useState<string>('');
    const [lottieLoading, setLottieLoading] = useState<any>(false);
    const [loadingHistoric, setLoadingHistoric] = useState<any>(false);

    const handleInitConversation = () => {
        if (params.get('action') === EProblemTypeEvent.DIAGNOSIS_RESUMED) {
            return [
                {
                    component: <ChatDiagnosisDynamic problemId={params.get('id')!}></ChatDiagnosisDynamic>,
                },
            ];
        } else {
            return [
                {
                    component: (
                        <ChatTabsProducts
                            products={products}
                            onEmitProduct={(product: IChatComponent) => handleProduct(product)}
                        ></ChatTabsProducts>
                    ),
                },
            ];
        }
    };

    const [items, setItems] = useState<IChatItemComponent[] | undefined>();
    let components: IChatItemComponent[] = handleInitConversation();
    const [windowWidth, setWindowWidth] = useState<any>(window.innerWidth);

    const handleProduct = (item: IChatComponent) => {
        const { step, product } = item;
        if (step === 2) {
            const _components = {
                component: (
                    <ChatNumberProduct
                        item={item}
                        onEmitNumber={(number: IChatComponent) => handleProduct(number)}
                    ></ChatNumberProduct>
                ),
            };
            updateArrayComponents(_components);
        }
        if (step === 3) {
            if (product?.motive) {
                const _components = {
                    component: (
                        <ChatIncidenteContactNumber
                            problem={product}
                            onEmitContactNumber={(contactNumber: IChatComponent) => handleProduct(contactNumber)}
                        ></ChatIncidenteContactNumber>
                    ),
                };
                updateArrayComponents(_components);
            } else {
                const _components = {
                    component: (
                        <ChatMotivesProblem
                            product={item}
                            treeMotives={product.motive ? [product.motive] : false}
                            onEmitMotive={(motive: IChatComponent) => handleProduct(motive)}
                        ></ChatMotivesProblem>
                    ),
                };
                updateArrayComponents(_components);
            }
        }
        if (step === 4) {
            const { id, treeMotives } = product.motive;
            if (!treeMotives) {
                setLottieLoading(true);
                getListMotivesById({ categoryId: id })
                    .then((response: AxiosResponse) => {
                        const { data } = response;
                        setLottieLoading(false);
                        const _components = {
                            component: (
                                <ChatMotivesProblem
                                    product={item}
                                    treeMotives={data}
                                    onEmitMotive={(motive: IChatComponent) => handleProduct(motive)}
                                ></ChatMotivesProblem>
                            ),
                        };
                        updateArrayComponents(_components);
                    })
                    .catch((error: AxiosError) => {
                        console.error(error);
                        setLottieLoading(false);

                        const queryParams = {
                            phase: EProblemFeedbackType.ERROR,
                            error: EProblemFeedback.DIAGNOSIS,
                            ...literalsFeedback(EProblemFeedback.DIAGNOSIS),
                        };
                        if (navigateParams('feedback-error', '/support/incidents-feedback', queryParams)) {
                            navigate(
                                `/support/incidents-feedback?phase=${queryParams.phase}&error=${queryParams.error}`,
                            );
                        }
                    });
            } else {
                const _components = {
                    component: (
                        <ChatIncidenteContactNumber
                            problem={product}
                            onEmitContactNumber={(contactNumber: IChatComponent) => handleProduct(contactNumber)}
                        ></ChatIncidenteContactNumber>
                    ),
                };
                updateArrayComponents(_components);
            }
        }
        if (step === 5) {
            const _components = {
                component: <ChatSupportChecks></ChatSupportChecks>,
            };
            updateArrayComponents(_components);
        }
        if (step === 6) {
            const _components = {
                component: <ChatDiagnosisDynamic problemId={product.problemId!}></ChatDiagnosisDynamic>,
            };
            updateArrayComponents(_components);
        }
    };

    const handleGetHistoricMessages = async (events: IProblemEvent[]) => {
        const promises = events.map((event: IProblemEvent) =>
            getProblemDialogById({ dialogId: event.dialogId, problemId: params.get('id')! }),
        );
        const _promises = await Promise.allSettled(promises).finally(() => setLoadingHistoric(false));
        const messages = _promises.map((item: any) => {
            const { value } = item;
            const { data } = value;
            return data;
        });

        return messages.map((item: IProblemQuestion, index: number) => {
            const response = events.filter((resp: IProblemEvent) => resp.dialogId === item.id)[0]?.responseId;
            const { question, responses } = item;

            return {
                question,
                answer: responses?.filter((ans: IProblemResponse) => ans.id === response)[0].text,
            };
        });
    };

    const handleGetContactHistoric = (
        interactionRole: IProblemInteractionRole[],
        contacts: { id: string; contact: IProblemContact[] },
    ) => {
        const isTelf = interactionRole.filter((cont) => cont.type === '3')[0].customerContactId;
        return contacts?.contact?.filter((phone: IProblemContact) => isTelf === phone.id)[0]?.value;
    };

    const handleGetProductHistoric = (product: string) => {
        const getProduct = () => {
            const cases: { [key: string]: any } = {
                mobiles: products?.mobiles?.filter((_mobile: any) => _mobile.productId === product),
                main: products?.bundles[0]?.mainMobile?.productId === product,
                additional: products?.bundles[0]?.additionalMobiles?.filter(
                    (_mobile: any) => _mobile.productId === product,
                )[0],
                phoneHome: products?.bundles[0]?.fiber?.productId === product,
                fiber: products?.fibers?.filter((_fiber: any) => _fiber.productId === product),
            };
            const setProduct = (type: string, phone: string) => {
                return { type, phone };
            };
            let _product = {
                type: '',
                phone: '',
            };

            if (cases.phoneHome) {
                _product.type = setProduct('phoneHome', products?.bundles[0]?.fiber?.number).type;
                _product.phone = setProduct('phoneHome', products?.bundles[0]?.fiber?.number).phone;
            } else if (cases.fiber) {
                _product.type = setProduct('fiber', products?.bundles[0]?.fiber?.number).type;
                _product.phone = setProduct('fiber', products?.bundles[0]?.fiber?.number).phone;
            } else if (cases.mobiles) {
                _product.type = setProduct('mobile', cases.mobiles[0]?.number).type;
                _product.phone = setProduct('mobile', cases.mobiles[0]?.number).phone;
            } else if (cases.main) {
                _product.type = setProduct('mobile', products?.bundles[0]?.mainMobile?.number).type;
                _product.phone = setProduct('mobile', products?.bundles[0]?.mainMobile?.number).phone;
            } else if (cases.additional) {
                _product.type = setProduct('mobile', cases.additional?.number).type;
                _product.phone = setProduct('mobile', cases.additional?.number).phone;
            }

            return _product;
        };

        const literalsType: { [key: string]: string } = {
            fiber: t('supportResponseChatTabsProductsFibra'),
            mobile: t('supportResponseChatTabsProductsMovil'),
            phoneHome: t('supportResponseChatTabsProductsFijo'),
        };

        return {
            type: literalsType[getProduct().type],
            line: getProduct()?.phone,
        };
    };

    const handleGetHistoricIssue = async () => {
        setLoadingHistoric(true);
        getProblemById({ problemId: params.get('id')! })
            .then((response: AxiosResponse) => {
                getListContactsProblems()
                    .then((contacts: AxiosResponse) => {
                        getEventsProblemById({ problemId: params.get('id')! })
                            .then(async (eventsResponse: AxiosResponse) => {
                                const { data }: { data: IProblemEvent[] } = eventsResponse;
                                const events: IProblemEvent[] = (orderArrayDates(data, 'createdAt') as []).filter(
                                    (event: IProblemEvent) =>
                                        event.type === EProblemTypeEvent.ANSWER && event.responseId !== null,
                                );
                                const messages = await handleGetHistoricMessages(events);
                                setDateIssue(orderArrayDates(data, 'createdAt')[0].createdAt);
                                const _messages: IProblemHistoricMessage[] = [
                                    {
                                        question: t('supportChatAnswerTabProduct'),
                                        answer: handleGetProductHistoric(response.data.product.id)?.type,
                                    },
                                    {
                                        question: t('supportAnswerChatNumbers'),
                                        answer: handleGetProductHistoric(response.data.product.id)?.line,
                                    },
                                    {
                                        question: t('supportChatMotiveProblemAnswer'),
                                        answer: response.data.motive.description,
                                    },
                                    {
                                        question: t('supportChatNewContactPhoneAnswer'),
                                        answer: `${handleGetContactHistoric(
                                            response.data.interactionRoles,
                                            contacts.data,
                                        )}`,
                                    },
                                    ...messages,
                                ];
                                setMessages(_messages);
                            })
                            .catch((error: AxiosError) => {
                                console.error(error);
                                setLoadingHistoric(false);
                                const queryParams = {
                                    phase: EProblemFeedbackType.ERROR,
                                    error: EProblemFeedback.DIAGNOSIS,
                                    ...literalsFeedback(EProblemFeedback.DIAGNOSIS),
                                };
                                if (navigateParams('feedback-error', '/support/incidents-feedback', queryParams)) {
                                    navigate(
                                        `/support/incidents-feedback?phase=${queryParams.phase}&error=${queryParams.error}`,
                                    );
                                }
                            });
                    })
                    .catch((error: AxiosError) => {
                        console.error(error);
                        setLoadingHistoric(false);
                        const queryParams = {
                            phase: EProblemFeedbackType.ERROR,
                            error: EProblemFeedback.SERVICE,
                            ...literalsFeedback(EProblemFeedback.SERVICE),
                        };
                        if (navigateParams('feedback-error', '/support/incidents-feedback', queryParams)) {
                            navigate(
                                `/support/incidents-feedback?phase=${queryParams.phase}&error=${queryParams.error}`,
                            );
                        }
                    });
            })
            .catch((error: AxiosError) => {
                console.error(error);
                setLoadingHistoric(false);
                const queryParams = {
                    phase: EProblemFeedbackType.ERROR,
                    error: EProblemFeedback.SERVICE,
                    ...literalsFeedback(EProblemFeedback.SERVICE),
                };
                if (navigateParams('feedback-error', '/support/incidents-feedback', queryParams)) {
                    navigate(`/support/incidents-feedback?phase=${queryParams.phase}&error=${queryParams.error}`);
                }
            });
    };

    const updateArrayComponents = (product: IChatItemComponent) => {
        components.push(product);
        let _items = components.map((item: any) => item);
        setItems(_items as any);
    };

    const setComponent = (component: JSX.Element) => component;

    useEffect(() => {
        if (Object.values(products).some((product: any) => product?.length > 0)) {
            if (params.get('action') === EProblemTypeEvent.DIAGNOSIS_RESUMED) handleGetHistoricIssue();
        }
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
        window.addEventListener('resize', handleResize);

        setItems(handleInitConversation() as []);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [products]);

    if (loadingHistoric) {
        return (
            <div className='c-spinner'>
                <Spinner size={24} />
                <span style={{ background: 'white' }} className='c-spinner-overlay'></span>
            </div>
        );
    }

    return supportDisabled ? (
        <Stopper></Stopper>
    ) : (
        <div className='solveIncident-page'>
            <div className='solveIncident-page__header' style={{ background: skinVars.colors.backgroundBrand }}>
                {!(isWebviewAndroid || isWebviewIOS) && (
                    <>
                        <div className='solveIncident-page__header-navigationBar'>
                            <NavigationBar
                                isInverse={true}
                                onBack={() => {
                                    navigate('/support');
                                }}
                                title={t('supportContentRowSolveIncidentTitle')}
                            />
                        </div>
                        <div className='solveIncident-page__header-return'>
                            <div
                                className='solveIncident-page__header-return-cursor'
                                onClick={() => {
                                    navigate('/support');
                                }}
                            >
                                <div className='solveIncident-page__header-return-cursor-icon'>
                                    <IconChevronLeftRegular color={skinVars.colors.appBarBackground} size={20} />
                                </div>
                                <Text2 medium color={skinVars.colors.appBarBackground}>
                                    {t('returnResponsive')}
                                </Text2>
                            </div>
                        </div>
                    </>
                )}
                <div className='solveIncident-page__header-breadcrumbs'>
                    <ThemeVariant isInverse>
                        <BreadCrumbsWrapper
                            title={t('supportContentRowSolveIncidentTitle')}
                            breadcrumbs={[{ title: t('breadcrumbsSupport'), url: '/support' }]}
                        />
                    </ThemeVariant>
                </div>
            </div>
            <div className='solveIncident-page__content' ref={ref}>
                <div className='solveIncident-page__content-img'>
                    <img
                        src={'https://dlvt1u0vrr0ux.cloudfront.net/media/public/incidencias2x.png'}
                        alt='Soporte O2'
                        width='100%'
                        height={height}
                    />
                </div>
                <div
                    className='solveIncident-page__content-chat'
                    style={{
                        background: windowWidth >= 1024 ? skinVars.colors.background : '',
                        maxHeight: height,
                    }}
                >
                    {params.get('action') === EProblemTypeEvent.DIAGNOSIS_RESUMED && (
                        <>
                            <div className='solveIncident-page__content-chat-titleDate'>
                                <Text2 medium>{getFormatDate(`${new Date()}`, 'DDDD 00, MMMM')}</Text2>
                            </div>
                            {messages?.map(({ question, answer }: IProblemHistoricMessage, key: number) => {
                                return (
                                    <Box paddingBottom={16} key={key}>
                                        <ChatSupport text={question} html={true}></ChatSupport>
                                        <ChatText context='response' text={answer}></ChatText>
                                    </Box>
                                );
                            })}
                        </>
                    )}
                    <div className='solveIncident-page__content-chat-titleDate'>
                        <Text2 medium>
                            {params.get('action') === EProblemTypeEvent.DIAGNOSIS_RESUMED
                                ? getFormatDate(`${new Date(dateIssue)}`, 'DDDD 00, MMMM')
                                : getFormatDate(`${new Date()}`, 'DDDD 00, MMMM')}
                        </Text2>
                    </div>
                    <div className='solveIncident-page__content-chat-date'>
                        <Text1 medium color={skinVars.colors.textSecondary}>
                            {getFormatDate(currentDate, '00:00')}
                        </Text1>
                    </div>
                    {items?.map((item: IChatItemComponent, index: number) => {
                        const { component } = item;
                        return <div key={index}>{setComponent(component)}</div>;
                    })}
                    {lottieLoading && LoaderMessage}
                </div>
            </div>
        </div>
    );
};

export default SolveIncident;
